import { Environment } from '@/enums/environment';

const ENVIRONMENT_HOSTNAMES: Record<Environment, string> = {
    [Environment.LOCAL]: 'localhost',
    [Environment.DEV]: 'dev.gpp.gls-group.com',
    [Environment.STAGE]: 'stage.gpp.gls-group.com',
    [Environment.PROD]: 'gpp.gls-group.com'
};

export { ENVIRONMENT_HOSTNAMES };
